export class Conversione {

    /**
     Restituisce un oggetto Number ricevendo in ingresso una stringa che rappresenta un ora espressa comme hhmm
     N.B. il numero decimale restituito rappresenta l'ora in ore e centesimi di ora
     *
     * @param value
     * @returns {Number}
     */
    static hhmm2hhcc = function (value: string | null | undefined): number {
        if (!value || value === '' || value === '0000') {
            return 0;
        }
        const ore = Number(value.substring(0, 2)), minuti = Number(value.substring(2));
        let centesimi = Math.round(100 * minuti / 60);
        centesimi /= 100.0;
        let number = ore;
        number += Number(centesimi);
        //console.log(number);
        return number;
    };

    static hhmm2String = function (value: string | null, defIfNUll: string = '00:00'): string {
        if (value && value.length === 4) {
            const ore = value.substring(0, 2);
            const minuti = value.substring(2);
            return ore + ':' + minuti;
        } else {
            return defIfNUll;
        }
    };
}